module.exports = __webpack_public_path__ + "img/avatar_real_5.52d005c6.jpg";